export enum Integrations {
  TASKS = "tasks",
  GCALENDAR = "gcalendar",
  TODOIST = "todoist",
  PAYMO = "paymo",
  JIRA = "jira",
  ASANA = "asana",
}
